import model from '../mixins/model';
import {isVerificationCode} from "@/services/vault";

export default {
    mixins: [model],
    form: true,
    model() {
        return {
            code: ''
        }
    },
    data() {
        return {
            starting: false,
            startFailed: false
        }
    },
    mounted() {
        this.start();
    },
    methods: {
        canSubmit() {
            return !!this.$auth.flow.setup && isVerificationCode(this.model.code);
        },
        start() {
            this.starting = true;
            this.startFailed = false;

            this.$auth.setupTwoFactor()
                .catch(() => {
                    this.startFailed = true;
                })
                .finally(() => {
                    this.starting = false;
                });
        },
        submit(e) {
            e.preventDefault();

            if (!this.canSubmit() || this.loading)
                return;

            this.dispatch((resolve, reject) => {

                this.$auth.confirmTwoFactor(this.model.code).then(resolve).catch(reject);

            }).then((status) => {

                if (status === 'VERIFIED')
                    this.$router.push({name: "agent"});
            }).catch(() => {
                this.model.code = '';
            });
        }
    }
}
